import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

/* <html lang> suit la langue du site (index.html est fige sur "en") :
   sans ca, sur /zh Chrome propose « Traduire depuis l'anglais » et peut
   choisir une police CJK non chinoise. Pose aussi le titre d'onglet par
   defaut, traduit ; les pages qui ont leur propre <title> le remplacent
   (react-helmet : la derniere instance montee l'emporte).
   NB : pas de dir="rtl" pour l'arabe ici, la mise en page n'a jamais ete
   verifiee en RTL. */
const HtmlLang = () => {
  const { t, i18n } = useTranslation();
  const l = String(i18n.language || "en").toLowerCase().split(/[-_]/)[0];
  const lang = l === "zh" ? "zh-CN" : l;
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{t("signal.seo-default-title")}</title>
    </Helmet>
  );
};

export default HtmlLang;
